<template>
  <div class="contact-info text-justify">
    <div class="container">
      <h1>Contact information</h1>
      <label for="company-name">Company name:</label>
      <input
        class="form-control"
        type="text"
        name="company-name"
        v-model="$store.state.subscriberData.CompanyName"
      />
      <label for="company-name">Company phone number:</label>
      <input
        class="form-control"
        type="tel"
        name="company-phone"
        v-model="$store.state.subscriberData.CompanyPhone"
      />
      <label for="company-name">Company email address:</label>
      <input
        class="form-control"
        type="email"
        name="company-email"
        v-model="$store.state.subscriberData.CompanyEmail"
      />
      <h4>Address</h4>
      <AddressForm name="Company" />
      <div class="row">
        <div class="col-sm-6">
          <h4>Postal address</h4>
          <p>Do you have a different postal address than the above address?</p>
          <YesNo v-model="hasPostal" name="postal" />
          <AddressForm name="Postal" v-if="hasPostal" />
        </div>
        <div class="col-sm-6">
          <h4>Invoice address</h4>
          <p>Do you have a different invoice address than the above address?</p>
          <YesNo v-model="hasInvoice" name="invoice" />
          <AddressForm name="Invoice" v-if="hasInvoice" />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <h4>Main contact person</h4>
          <EmployeeForm employeeNr="1" />
        </div>
        <div class="col-sm-6">
          <h4>Secondary contact person</h4>
          <EmployeeForm employeeNr="2" />
        </div>
      </div>
      <br />
      <router-link to="/subscribe/intro">
        <button class="btn btn-secondary">Back</button>
      </router-link>
      <router-link to="/subscribe/study-selection">
        <button class="btn btn-primary">Next</button>
      </router-link>
    </div>
  </div>
</template>

<script>
import countries from "@/countries.js";
import AddressForm from "@/components/AddressForm.vue";
import EmployeeForm from "@/components/EmployeeForm.vue";
import YesNo from "@/components/YesNo.vue";

export default {
  name: "ContactInfo",
  components: {
    AddressForm,
    EmployeeForm,
    YesNo
  },
  data() {
    // TODO: Vuex
    return {
      hasPostal: !!this.$store.state.subscriberData.PostalAddress,
      hasInvoice: !!this.$store.state.subscriberData.InvoiceAddress
    };
  },
  watch: {
    hasPostal(newState) {
      if (newState) {
        this.postalAddress = {};
      }
    },
    hasInvoice(newState) {
      if (newState) {
        this.invoiceAddress = {};
      }
    }
  }
};
</script>

<style lang="scss">
.container {
  h4 {
    margin-top: 1.5em;
  }
}
</style>